export const BRAND = {
  name: '摸鱼岛',
  english: 'MOYU ISLAND',
  tagline: '忙里偷闲，快乐靠岸。',
  title: '摸鱼岛 — 在线小游戏，即点即玩',
  description:
    '摸鱼岛是你的小游戏休息站，发现益智、休闲、经营和对战游戏，无需下载安装，打开浏览器即可开始。忙里偷闲，快乐靠岸。',
  heroTitle: '上岛摸鱼，快乐开局。',
  heroSubtitle: '把忙碌留在岸边。发现、收藏、即点即玩，在摸鱼岛给自己放个小假。',
  announcement: '欢迎来到摸鱼岛。收藏喜欢的游戏，下次上岛接着玩；也欢迎在留言板分享你的新发现。',
} as const;
